import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, inject, viewChild} from '@angular/core'
import {MatTab, MatTabContent, MatTabGroup} from '@angular/material/tabs'
import {WelcomeComponent} from '../2-welcome/welcome.component'
import {ScannerComponent} from '../3-scanner/scanner.component'
import {IdListComponent} from '../4-id-list/id-list.component'
import {HelpComponent} from '../5-help/help.component'

import 'hammerjs'

@Component({
  selector: 'spb-start',
  templateUrl: './start.component.html',
  imports: [
    MatTabGroup,
    MatTab,
    WelcomeComponent,
    ScannerComponent,
    IdListComponent,
    HelpComponent,
    MatTabContent
  ]
})
export class StartComponent implements AfterViewInit {
  public tabGroup = viewChild.required<MatTabGroup>('tabGroup')
  public swipeContainer = viewChild.required<ElementRef>('swipeContainer')
  private readonly cdRef = inject(ChangeDetectorRef)

  public ngAfterViewInit() {
    const hammer = new Hammer(this.swipeContainer().nativeElement)
    hammer.on('swipeleft', this.swipeLeft)
    hammer.on('swiperight', this.swipeRight)
  }

  public swipeLeft = () => {
    const currentIndex = this.tabGroup().selectedIndex
    if (currentIndex !== null && currentIndex < 3) {
      this.tabGroup().selectedIndex = currentIndex + 1
      // Must trigger change since tab group is not signal based
      this.cdRef.detectChanges()
    }
  }

  public swipeRight = () => {
    const currentIndex = this.tabGroup().selectedIndex
    if (currentIndex !== null && currentIndex > 0) {
      this.tabGroup().selectedIndex = currentIndex - 1
      // Must trigger change since tab group is not signal based
      this.cdRef.detectChanges()
    }
  }
}